import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ChefAvtarHost from '../Chef/ChefAvtarHost'
import ChefInfo from '../Chef/ChefInfo'
import moment from 'moment'

export default class ExperienceCard extends Component {
  render() {
    const {
      experience,
      featured,
      hideAvatar,
      forceHoverState,
      isUpcoming
    } = this.props

    let extraClassNames = ''
    extraClassNames += featured ? ' experience-card--featured' : ''
    extraClassNames += forceHoverState ? ' grid-view-item--force-hover' : ''
    extraClassNames += hideAvatar ? ' experience-card--avatar-hidden' : ''
    extraClassNames += isUpcoming ? ' experience-card--upcoming' : ''
    experience.readableTime = experience.time
      ? experience.time
      : experience.readableTime

    let experienceStatusForRender = ''
    if (experience.status === 'paused') {
      experienceStatusForRender = 'Paused'
    } else if (experience.featured) {
      experienceStatusForRender = 'Featured'
    }

    let inPast = false
    if (experience.dateWithTime) {
      if (moment(experience.dateWithTime).isBefore(moment(new Date()).utc())) {
        inPast = true
      }
    } else {
      inPast = true
    }

    let startedDate = moment.utc(new Date())

    let schedules = experience.schedules.filter((el) => {
      if (moment(`${el.date}T${experience.time}Z`).isBefore(startedDate) || el.status !== 'active') {
        return false
      }
      return true
    })

    let scheduleTime = '';
    if (schedules && schedules.length > 0) {
      const upCommingSchedules = schedules.sort((a, b) => new Date(a.scheduleTime) - new Date(b.scheduleTime))

      if (upCommingSchedules.length < 1) {
        scheduleTime = 'Coming Soon';
      } else if (upCommingSchedules.length > 1) {
        scheduleTime = `${moment(upCommingSchedules[0].date).format('ddd Do MMM')} & more dates`;
      } else {
        scheduleTime = `${moment(upCommingSchedules[0].date).format('ddd Do MMM')}`;
      }
    }

    const linkStyle = { textDecoration: 'none', color: 'inherit' };

    return (
      <React.Fragment>
        <div className={`experience-card grid-view-item ${extraClassNames}`}>
          {/* Link 1: Image Area */}
          <Link to={`/experiences/${experience.slug}`} style={{ textDecoration: 'none' }}>
            <div className="experience-card__image--container grid-view-item__link grid-view-item__image-container">
              <div className="grid-view-item__image-wrapper js">
                <div id="" className="grid-view-item__image-wrapper js">
                  <div className="grid-view-item__image-container">
                    <div
                      className="grid-view-item__overlay box ratio-container lazyload js"
                      data-sizes="auto"
                      data-parent-fit="cover"
                      style={{
                        backgroundImage: `url("${experience.image}")`
                      }}
                    />
                    <div className="experience-card__hover-meta grid-view-item_hover-el">
                      <span className='line-clamp-5'>{experience.summary}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Link>

          {/* Metadata Section - No longer wrapped in a single parent Link */}
          <div className="experience-card__meta grid-view-item__meta">
            <Link to={`/experiences/${experience.slug}`} style={linkStyle}>
              <div className="experience-card__high-level">
                <div className="experience-card__location">
                  {experience.location ? experience.location.city : ''}
                </div>
                <div className="experience-card__tools text-uppercase">
                  <b>{experienceStatusForRender}</b>
                  {experience.status === 'submitted' ? (
                    <span className="experience-card__location" style={{ width: '100%', padding: '3px 0px' }}>
                      Coming Soon
                    </span>
                  ) : ''}
                  {experience.status === 'approved' && !inPast ? (
                    <span className="experience-card__location" style={{ width: '100%', padding: '3px 0px 3px 42px' }}>
                      Live
                    </span>
                  ) : ''}
                </div>
              </div>
            </Link>

            {/* Avatar - Contains its own Link internally */}
            {!hideAvatar && (
              <ChefAvtarHost displayInfo={false} person={experience.host} />
            )}

            <div className="experience-card__text grid-view-item__text">
              {/* Chef Info - Contains its own Link internally */}
              {!hideAvatar && (
                <ChefInfo
                  displaySpecialties={false}
                  person={experience.host}
                />
              )}

              <Link to={`/experiences/${experience.slug}`} style={linkStyle}>
                <div className="experience-card__title grid-view-item__title">
                  <h5>{experience.title}</h5>
                  <big className=" text-secondary text-sm">{scheduleTime}</big>
                </div>

                {experience.cuisineTypes
                  && experience.cuisineTypes.map((specialty, i) => (
                    <small className=" text-primary experience-description" key={specialty.id}>
                      {specialty.name}
                      {experience.cuisineTypes.length - 1 !== i && (
                        <span>, </span>
                      )}
                    </small>
                  ))}
              </Link>
            </div>
          </div>

          {!isUpcoming && (
            <Link to={`/experiences/${experience.slug}`} style={linkStyle}>
              <div className="experience-card__reservation-info group ">
                <div className="experience-card__price">
                  <span className='experience-card__currency'>{experience.currency}</span>
                  <p className='experience-card__currency__value'>{experience.price}</p>
                </div>
                <div
                  className="experience-card__date"
                  style={{ borderLeft: 'none' }}
                >
                  <span className='experience-card__type'>Type</span>{' '}
                  {experience.experienceType ? (
                    <p>
                      {experience.experienceType.name}
                    </p>
                  ) : ''}
                </div>
              </div>
            </Link>
          )}
        </div>
      </React.Fragment>
    )
  }
}

ExperienceCard.defaultProps = {
  featured: false,
  hideAvatar: false,
  forceHoverState: false,
  isUpcoming: false
}

ExperienceCard.propTypes = {
  experience: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    // city: PropTypes.string.isRequired, // Note: Removed this check as it might be missing in some objects
    host: PropTypes.shape({
      fullname: PropTypes.string,
      avatarUrl: PropTypes.string,
      specialties: PropTypes.arrayOf(PropTypes.shape({})).isRequired
    })
  }).isRequired,
  featured: PropTypes.bool,
  hideAvatar: PropTypes.bool,
  forceHoverState: PropTypes.bool,
  isUpcoming: PropTypes.bool
}